import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasPermission } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { userRole } = useAuth();

  console.log('ProtectedRoute check:', { userRole, requiredPermission });

  if (!hasPermission(userRole, requiredPermission)) {
    console.log('Redirecting to sign-in due to lack of permission');
    return <Navigate to="/signin" />;
  }

  return children;
};

export default ProtectedRoute; 